<template>
  <div class="card_box" v-for="(item,index) in productService" :key="item.id">
    <div :class="`box_inner_${index} sp_inner_box_vip_product`">
      <div class="title_name">
        <span v-if="item.productSort===1">{{ $t('userinfo.vip.service.1') }}</span>
        <span v-else-if="item.productSort===2">{{ $t('userinfo.vip.service.2') }}</span>
        <span v-else-if="item.productSort===3">{{ $t('userinfo.vip.service.3') }}</span>
        <span v-else-if="item.productSort===4">{{ $t('userinfo.vip.service.4') }}</span>
      </div>
      <div style="margin-top: 5px" class="des">
        <template v-if="item.productSort===1">
          {{ $t('common.text.per.station.year', {number: item?.productNum}) }}
        </template>
        <template v-else-if="item.productSort===2">
          {{ $t('common.text.per.GB.year', {number: spaceSizeFormat(item?.productNum, false)}) }}
        </template>
        <template v-else-if="item.productSort===3">
          {{ $t('common.text.per.feng.year', {number: item?.productNum}) }}
        </template>
        <template v-else-if="item.productSort===4">
          {{ $t('common.text.per.year', {number: item?.productNum}) }}
        </template>
      </div>
      <div class="pre_price">
        {{ $t('common.yj', {price: item.productPrice}) }}
      </div>
      <div class="price_box">
        <span class="red ft-12">¥</span>
        <span class="red ft-24">{{ item.productCheapPrice.toFixed(2) }}</span>
        <div class="vip-price-tag">
          {{ $t('common.product.price.member') }}
          <div class="triangle"></div>
        </div>
      </div>
      <div style="margin-top: 6px;">
        <div class="buy_button" @click="handleClickToBuy(item,1)">{{ $t('common.buy.now') }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {i18n} from "@/lang";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {spaceSizeFormat} from "../../../utils/file";

// const productService = ref([
//   {
//     id: 1,
//     name: i18n.global.t('userinfo.vip.service.1'),
//     price: 69,
//     prePrice: 99,
//     des: "1个/1年"
//   },
//   {
//     id: 2,
//     name: i18n.global.t('userinfo.vip.service.2'),
//     price: 49,
//     prePrice: 69,
//     des: "5G/1年"
//   },
//   {
//     id: 3,
//     name: i18n.global.t('userinfo.vip.service.3'),
//     price: 209,
//     prePrice: 299,
//     des: "10000封/1年"
//   },
//   {
//     id: 4,
//     name: i18n.global.t('userinfo.vip.service.4'),
//     price: 19,
//     prePrice: 29,
//     des: "100000点/1年"
//   }
// ])
const store = useStore()

const productService = computed(() => store.state.buystorage.allProductList)

const router = useRouter()
const handleClickToBuy = async (item, type) => {
  const {id, productSort} = item;
  // await store.commit("buystorage/setCheckIndex", id * 1)
  router.push({path: '/personal/buystorage', query: {indexId: id, productSort: productSort, type: type}})
}

onMounted(async () => {
  await store.dispatch("buystorage/getMailProductListApis", 1)
})

</script>

<style lang="less" scoped>
.card_box {
  width: 24%;
  min-height: 153px;
  height: max-content;
  border-radius: 5px;
}

.sp_inner_box_vip_product {
  width: 100%;
  height: 100%;
  padding: 15px;

  .title_name {
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
  }

  .des {
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #9B9B9B;
  }

  .price_box {
    margin-top: 5px;
    text-align: center;
    height: 30px;
  }

  .pre_price {
    margin-top: 5px;
    text-align: center;
    //text-decoration: line-through;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #AAAAAA;
  }
}

.box_inner_0 {
  background: url("../../../assets/vip/product_1.png") no-repeat center/cover;
}

.box_inner_1 {
  background: url("../../../assets/vip/product_2.png") no-repeat center/cover;
}

.box_inner_2 {
  background: url("../../../assets/vip/product_3.png") no-repeat center/cover;
}

.box_inner_3 {
  background: url("../../../assets/vip/product_4.png") no-repeat center/cover;
}

.ft-12 {
  font-size: 12px;
}

.ft-24 {
  font-size: 24px;
}

.red {
  color: #D93737;
}

.vip-price-tag {
  width: 42px;
  position: relative;
  left: 76%;
  top: -35px;
  background-color: #F2270C;
  color: #fff;
  font-size: 10px;
  padding: 0 6px;
  height: 14px;
  line-height: 14px;
  border-radius: 3px 3px 3px 0px;
  font-weight: bold;
  text-align: center;
}

/* 下方小三角 */
.triangle {
  position: absolute;
  bottom: -4px;
  left: 3px;
  top: 6px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #F2270C; /* 红色三角向右 */
}

.buy_button {
  margin: auto;
  width: 130px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: rgba(217, 55, 55, 0.15);
  border-radius: 4px;
  border: 1px solid #D93737;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #D93737;
  cursor: pointer;
}


</style>